import React from 'react';
import { useDocumentOverflow } from 'root/src/client/v2/common/contexts/modal.context';
import { useIsMobileResolution } from 'root/src/client/v2/browser/hooks/useIsMobileResolution';
export const DareFiltersContext = React.createContext(null);
export const useDaresFilter = () => {
    const context = React.useContext(DareFiltersContext);
    if (!context) {
        throw new Error('useDareFilters must be used within a DareFiltersProvider');
    }
    return context;
};
export const DaresFiltersProvider = React.memo((props) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const overflow = useDocumentOverflow();
    const { isMobileResolution } = useIsMobileResolution();
    React.useEffect(() => {
        if (isOpen) {
            if (isMobileResolution)
                overflow.hide();
            else if (!isMobileResolution)
                overflow.show();
        }
    }, [isOpen, isMobileResolution]);
    const handleOpenChange = (value) => {
        if (!value) {
            overflow.show();
        }
        setIsOpen(value);
    };
    const context = React.useMemo(() => {
        return {
            drop: props.drop,
            state: props.value,
            options: props.options,
            onFilterChange: props.onFilterChange,
            isOpen,
            setIsOpen: handleOpenChange,
            resetFilters: () => props.onFilterChange({
                platforms: [],
                levels: [],
                tiers: [],
                battlePasses: [],
            }),
        };
    }, [props.value, props.onFilterChange, props.options, isOpen]);
    return (<DareFiltersContext.Provider value={context}>
			{props.children}
		</DareFiltersContext.Provider>);
});
